<template>
    <div>
        <textarea
            :value="value"
            :placeholder="label"
            :class="{
                'border border-grey-200 bg-transparent rounded w-full placeholder-grey-200 text-grey-300 resize-none py-2 px-3 high-contrast:border-yellow-300 high-contrast:placeholder:text-yellow-300/50 high-contrast:text-yellow-300': true,
                'border-orange': hasErrors
            }"
            @input="$emit('input', $event.target.value)"
            @keyup.enter="submit()"
        />
        <span
            v-for="(error, index) in inputErrors"
            v-bind:key="`error-${index}`"
            class="validation-error">
                {{ error }}
        </span>

    </div>
</template>

<script>
export default {
    props: {
        value: String,
        name: {
            type: String,
            required: true
        },
        label: String,
        errors: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasValue() {
            return !_.isEmpty(this.value);
        },
        hasLabel() {
            return !_.isEmpty(this.label);
        },
        hasErrors() {
            return _.isArray(this.inputErrors) && this.inputErrors.length > 0;
        },
        inputErrors() {
            return _.get(this.errors, this.name, []);
        },
        inputPlaceholder() {
            return this.__(this.placeholder) ?? this.__(this.label);
        }
    },
    methods: {
        submit() {
            this.$emit("submitted");
        }
    }
};
</script>
